<template>
  <div class="user_dialog_father">
    <el-dialog :title="this.title"
               :label-position="right"
               v-if="visibleFlg"
               v-model="visibleFlg"
               :close-on-click-modal="false"
               :close-on-press-escape="true"
               width="400px"
               label-width="120px"
               @close="handleClose"
    >
      <el-form ref="form" :model="form" :rules="formRules" label-width="90px" class="addForm">
        <el-row>
          <el-form-item label="用户名" prop="name">
            <el-input v-model.trim="form.name" @blur="funTrim($event)" placeholder="请输入用户名"
                      :disabled="editFlg" clearable></el-input>
          </el-form-item>
        </el-row>
        <el-row v-if="editFlg">
          <el-form-item label="修改密码" prop="alertFlg">
            <el-select v-model="form.alertFlg" placeholder="是否修改密码">
              <el-option v-for="item in alertSelection" :key="item.key" :label="item.value"
                         :value="item.key"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row v-if="form.alertFlg">
          <el-form-item label="旧密码" prop="oldPassword">
            <el-input v-model.trim="form.oldPassword" @blur="funTrim($event)" placeholder="请输入旧密码"
                      type="password" clearable></el-input>
          </el-form-item>
        </el-row>
        <el-row v-if="form.alertFlg">
          <el-form-item label="新密码" prop="password">
            <el-input v-model.trim="form.password" @blur="funTrim($event)" placeholder="请输入新密码"
                      type="password" clearable></el-input>
          </el-form-item>
        </el-row>
        <el-row v-if="form.alertFlg">
          <el-form-item label="确认密码" prop="confirm">
            <el-input v-model.trim="form.confirm" @blur="funTrim($event)" placeholder="请确认新密码"
                      type="password" clearable></el-input>
          </el-form-item>
        </el-row>
        <el-row v-if="!editFlg">
          <el-form-item label="密码" prop="password">
            <el-input v-model.trim="form.password" @blur="funTrim($event)" placeholder="请输入密码"
                      type="password" clearable></el-input>
          </el-form-item>
        </el-row>
        <el-row v-if="!editFlg">
          <el-form-item label="确认密码" prop="confirm">
            <el-input v-model.tirm="form.confirm" @blur="funTrim($event)" placeholder="请确认密码"
                      type="password" clearable></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="过期时间" prop="dtExpiredTime">
            <el-date-picker v-model="form.dtExpiredTime" type="datetime" placeholder="选择日期时间"
                            clearable></el-date-picker>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="用户描述" prop="description">
            <el-input v-model.trim="form.description" @blur="funTrim($event)" placeholder="请输入内容" type="textarea"
                      :rows="3"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="1"></el-col>
          <el-col :span="22">
            <el-form-item>
              <el-button type="primary" @click="formSubmit('form')">保存</el-button>
              <el-button @click="handleClose()">关闭</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="1"></el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'userAddEditDialog',
  data() {
    var checkUserNameFormat = (rule, value, callback) => {
      let nameFormat = /^[A-Za-z_\d]{5,12}$/;
      if (nameFormat.test(value)) {
        callback();
      } else {
        callback(new Error("用户名由5-12位字母、数字或下划线组成"));
      }
    };
    var checkPasswordFormat = (rule, value, callback) => {
      let pdFormat = /[0-9A-Za-z]{6,16}$/;
      if (pdFormat.test(value)) {
        callback();
      } else {
        callback(new Error("请输入6-16位由数字或字母组成的密码"));
      }
    };
    var checkNewOldPassword = (rule, value, callback) => {
      if (value === this.form.oldPassword) {
        callback(new Error("新旧密码不能相同"));
      } else {
        callback();
      }
    };
    var checkPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致"));
      } else {
        callback();
      }
    };
    return {
      title: "添加用户",
      editFlg: false,
      visibleFlg: false,
      form: {
        id: '',
        name: '',
        confirm: '',
        password: '',
        oldPassword: '',
        dtExpiredTime: '',
        description: '',
        alertFlg: ''
      },
      alertSelection: [
        {key: true, value: '修改'},
        {key: false, value: '不修改'}
      ],
      formRules: {
        name: [
          {required: true, validator: checkUserNameFormat, trigger: 'blur'}
        ],
        alertFlg: [
          {required: true, message: " ", trigger: 'change'}
        ],
        oldPassword: [
          {required: true, validator: checkPasswordFormat, trigger: 'blur'}
        ],
        password: [
          {required: true, validator: checkPasswordFormat, trigger: 'change'},
          {validator: checkNewOldPassword, trigger: 'change'}
        ],
        confirm: [
          {required: true, validator: checkPassword, trigger: 'blur'}
        ],
        dtExpiredTime: [
          {required: true, message: "请选择过期时间", trigger: 'blur'}
        ],
        description: [
          {max: 1000, message: "请限制描述内容在1000字以内", trigger: 'blur'}
        ]
      },
    }
  },
  methods: {
    /**
     * @description 删除输入行首尾空格
     */
    funTrim(event) {
      event.srcElement.value = event.srcElement.value.trim();
    },
    /**
     * @description 关闭窗体并置空表单
     */
    handleClose() {
      this.visibleFlg = false;
      this.editFlg = false;
      this.form.alertFlg = '';
      this.title = "添加用户";
      this.resetForm('form');
    },
    /**
     * @description 重置表单
     */
    resetForm(formName) {
      this.$nextTick(() => {
        this.$refs[formName].resetFields();
      })
    },
    /**
     * @description 表单提交
     */
    formSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.title === '编辑用户') {
            this.$api.post(true, "/wx/auth/userManage/updateLoginUser", this.form, res => {
              if (res.data.statusCode === 'API-COMMON-INF-OK') {
                this.$message.success("修改成功");
                this.handleClose();
                this.$parent.queryVo.pageNum = 1;
                this.$parent.queryMessage();
              } else {
                this.$message.error(res.data.statusCode);
              }
            })
          } else {
            this.$api.post(true, "/wx/auth/userManage/saveLoginUser", this.form, res => {
              if (res.data.statusCode === 'API-COMMON-INF-OK') {
                this.$message.success("添加成功");
                this.handleClose();
                this.$parent.queryVo.pageNum = 1;
                this.$parent.queryMessage();
              } else {
                this.$message.error(res.data.statusMessage);
              }
            })
          }
        } else {
          this.$message.error("请检查必填项");
        }
      })
    }
  }
}
</script>
<style>
.user_dialog_father .el-input__inner {
  width: 220px;
}

.user_dialog_father .el-textarea__inner {
  width: 220px;
}

.el-form-item__error {
  width: 330px;
  font-size: 12px;
  color: red;
}

.user_dialog_father .el-dialog__header {
  height: 36px;
  padding: 0px;
  font-size: 14px;
  background-color: rgba(30, 160, 255, 1);
}

.user_dialog_father .el-dialog__title {
  color: white;
  font-size: 14px;
  line-height: 36px;
  padding-left: 20px;
}

.user_dialog_father .el-dialog__headerbtn {
  margin-top: -10px;
}

.user_dialog_father .el-dialog__body {
  padding: 20px 20px 0px 20px;
}

.user_dialog_father .el-dialog__headerbtn .el-dialog__close {
  color: #ffffff;
}

.user_dialog_father .el-dialog__headerbtn .el-dialog__close:hover {
  color: #bbb5b5;
}

.user_dialog_father .el-dialog__headerbtn .el-dialog__close:active {
  color: #ffffff;
}
</style>